import { Component, OnInit, AfterViewInit } from '@angular/core';
import { GRADIENT_ICONS } from 'src/app/constants/imagePath';
declare var AOS: any;
@Component({ selector: 'app-sdk-mobile', templateUrl: './mobile-sdk.component.html', styleUrls: ['./mobile-sdk.component.scss'], standalone: false })
export class MobileSDKComponent implements OnInit, AfterViewInit {
  activeSection = 'overview';
  sections = [
    { id: 'overview', label: 'Overview', icon: 'bx-layer' },
    { id: 'features', label: 'Features', icon: 'bx-mobile-alt' },
    { id: 'integration', label: 'Integration', icon: 'bx-code-alt' },
  ];
  features = [
    { icon: 'bx-mobile-alt', title: 'Android & iOS Native', desc: 'First-class Android (Kotlin/Java) and iOS (Swift/Obj-C) SDKs with full platform API access.' },
    { icon: 'bx-wifi', title: 'BLE & OBD Pairing', desc: 'Built-in BLE and OBD-II device pairing flow for plug-and-play hardware connectivity.' },
    { icon: 'bx-map-alt', title: 'Location & Trips', desc: 'Background trip tracking, geofence APIs, and location intelligence with battery-optimised operation.' },
    { icon: 'bx-bell', title: 'Push Notifications', desc: 'Vehicle event push notifications via FCM and APNs — crash alerts, ignition events, and custom triggers.' },
    { icon: 'bx-coin-stack', iconImage: GRADIENT_ICONS.MILES, title: 'Varroc Miles SDK', desc: 'Native integration with the Miles loyalty engine to automatically credit driving rewards.' },
    { icon: 'bx-lock-alt', title: 'Auth & Identity', desc: 'OAuth 2.0, biometric auth, and device binding for secure mobile-to-vehicle identity flow.' },
  ];
  ngOnInit() {}
  ngAfterViewInit() { try { AOS.refresh(); } catch (e) {} }
  scrollTo(id: string) {
    this.activeSection = id;
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
